import React, { useEffect, useRef } from 'react';
import { Alert, Box, Typography } from '@mui/material';

interface ScanInputProps {
  value: string;
  onChange: (v: string) => void;
  onScan: (value: string) => void;
  error: string | null;
  label?: string;
  placeholder?: string;
  shake?: boolean;
  focusTrigger?: number;
}

const ScanInput: React.FC<ScanInputProps> = ({
  value,
  onChange,
  onScan,
  error,
  label = 'Scan barcode',
  placeholder = 'Scan or type SKU / UPC…',
  shake = false,
  focusTrigger = 0,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const t = setTimeout(() => inputRef.current?.focus(), 50);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusTrigger]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return;
    const v = value.trim();
    onChange('');
    if (v) onScan(v);
    setTimeout(() => inputRef.current?.focus(), 50);
  };

  return (
    <Box>
      {label && (
        <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
          {label}
        </Typography>
      )}
      <input
        ref={inputRef}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus
        style={{
          width: '100%',
          fontSize: 18,
          padding: '10px 12px',
          border: shake ? '2px solid #d32f2f' : '2px solid #1976d2',
          borderRadius: 6,
          outline: 'none',
          boxSizing: 'border-box',
        }}
        placeholder={placeholder}
      />
      {error && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default ScanInput;
